import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FruHttpService } from '../../../../../services/fru-http.service';
import { Review } from '../../../../../shared/review';
import { BestService } from '../../../../../services/best.service';
import { HostListener } from "@angular/core";

@Component({
    selector: 'app-customer-review',
    templateUrl: './customer-review.component.html',
    styleUrls: ['./customer-review.component.scss'],
    standalone: false
})
/**
 * Consumer Reviews Component
 * Display Consumers Reviews as Slides
 * For Future use
 */
export class CustomerReviewComponent {

  showReviews = false;
  lengtOfCarousel:number;
  responseReviewsLength: number;
  id: number;
  reviews: Review[] = [];
  responseReviews: Review[];
  currentSlide: number;
  initialX: number;
  initialY: number;
  mobile = false;  

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.mobile = window.innerWidth < 900;
    this.lengtOfCarousel = this.mobile ? 1 : 3;
  }
  /**
   * host listener for keyboard events
   * @param event 
   */
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event) {
      let code = event.key;
      switch (code) {
        case "ArrowRight":
          this.moveToSlide(1);
          break;
        case "ArrowLeft":
          this.moveToSlide(-1);
          break;
      }
    }
  }
  //mobile events
  @HostListener('touchstart', ['$event'])
  startTouch(event) {
    this.initialX = event.touches[0].clientX;
    this.initialY = event.touches[0].clientY;
  };
  //mobile events
  @HostListener('touchmove', ['$event'])
  moveTouch(e) {
    //disabling until we have reviews in db
    return false;
    if (this.initialX === null) {
      return;
    }
    if (this.initialY === null) {
      return;
    }
    var currentX = e.touches[0].clientX;
    var currentY = e.touches[0].clientY;
    var diffX = this.initialX - currentX;
    var diffY = this.initialY - currentY;
    if (Math.abs(diffX) > Math.abs(diffY)) {
      if (diffX > 0) {
        // swiped left
        this.moveToSlide(1);
      } else {
        // swiped right
        this.moveToSlide(-1);
      }
    }
    this.initialX = null;
    this.initialY = null;
    if (e.stopPropagation) e.stopPropagation();
  };

  constructor(
    private fruHttp: FruHttpService,
    public best: BestService,
    private route: ActivatedRoute,
  ) {
    //get client id
    if (this.best.lender) {
      this.id = Number(this.best.lender);
    } else {
      this.route.queryParams.subscribe(params => {
        if (typeof params.l !== 'undefined' && params.l !== '') {
          this.id = params.l;
        }
      });
    }
    //get set of approved reviews from api call
    this.fruHttp.getConsumersReviews(this.id)
      .subscribe((response: Array<Review>) => {     
        // console.log('%c Consumers reviews : ', 'color:gold;',response);
        if (response) {
          this.showReviews = true;
          this.responseReviews = response;
          this.responseReviewsLength = this.responseReviews.length;
          this.currentSlide = 0;
          this.onResize();
          this.runSlides();
        }
      });
  }
  /**
   * step up in slides carousel
   */
  nextSlide() {
    this.moveToSlide(1);
  };
  /**
   * step down in slides carousel
   */
  prevSlide() {
    this.moveToSlide(-1);
  };

  private runSlides() {
    if (this.responseReviewsLength > 0) {
      this.moveToSlide(0);
      setInterval(() => {
        this.nextSlide();
      }, 15000);
    }
  }
  /**
   * 
   * @param adjustment 
   */
  private moveToSlide(adjustment: number) {

    this.currentSlide = this.currentSlide + adjustment;
    let arr = [];
    const last = this.lengtOfCarousel + this.currentSlide;
    const first = this.currentSlide;
    for (let index = first; index < last; index++) {
      this.currentSlide = (index + this.responseReviewsLength) % this.responseReviewsLength;
      arr.push(this.responseReviews[this.currentSlide]);
    }

    this.reviews = [...arr];

  }
}
